import { ComposeClient } from "@composedb/client";

import { definition } from "./__generated__/definition";

export const composeClient = new ComposeClient({
  ceramic: "https://ldg-node-mainnet.lateral.io/",
  definition,
});

export const fetcher = <TData, TVariables>(
  query: string,
  variables?: TVariables,
  options?: RequestInit["headers"]
): (() => Promise<TData>) => {
  return async () => {
    const json = await composeClient.executeQuery(query, variables ?? {});

    if (json.errors) {
      const { message } = json.errors[0] || {};
      throw new Error(message || "Error…");
    }

    return json.data as TData;
  };
};
